import React from 'react';
import TrafficMap from '../components/Map/TrafficMap'

const MapPage = () => {
  return <div><TrafficMap></TrafficMap></div>; 
};

export default MapPage;
